import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useDispatch } from 'react-redux';
import mixpanel from '../../utilities/mixpanel';
import { setServiceContract } from '../../redux/modules/app';
import { useUserInfo, useUserAccounts, useMasterId, useOpportunity, useIsPVHasEV, useIsMultiFamilyHome } from '../../hooks/useUser';
import { useSystemOverview } from '../../hooks/useSystem';
import { standardizeISODate } from '../../utilities/date';
import AddressSelector from './AddressSelector';

const AddressSelectorContainer = ({ drawerToggle }) => {
  const dispatch = useDispatch();
  const oppty = useOpportunity();
  const masterId = useMasterId();
  const systemInfo = useSystemOverview();
  const accounts = useUserAccounts();
  const userInfo = useUserInfo();
  const isPVHasEV = useIsPVHasEV();
  const [selectedOption, setSelectedOption] = useState(oppty?.opptyId);

  const isMFH = useIsMultiFamilyHome();

  useEffect(() => {
    setSelectedOption(oppty?.opptyId);
  }, [oppty]);

  const changeServiceContract = opptyId => {
    mixpanel.track('User Changed Service Contract Selected');
    drawerToggle();
    setSelectedOption(opptyId);
    const account = accounts.find(a => a.opptyId === opptyId);
    dispatch(setServiceContract(account, masterId, userInfo));
  };

  const options = [];

  if (accounts) {
    accounts.forEach(a => {
      if (a.address && a.opptyId) {
        const ptoDate = a?.contract?.ptoDate;
        let formattedDate;
        if (ptoDate) {
          const date = DateTime.fromISO(ptoDate, { zone: systemInfo.timezone });
          formattedDate = standardizeISODate(date);
        }
        if (isMFH) {
          options.push({ value: a.opptyId, label: `${a.opptyName || a.address}` });
        } else {
          options.push({ value: a.opptyId, label: `${a.address}${ptoDate ? ` (PTO ${formattedDate})` : ''}` });
        }
      }
    });
  }

  return (
    <AddressSelector
      address={isMFH ? oppty?.opptyName || oppty?.address : oppty?.address}
      changeServiceContract={changeServiceContract}
      opptyCount={userInfo.opportunityCount}
      options={options}
      selectedOption={selectedOption}
      isPVHasEV={isPVHasEV}
    />
  );
};

AddressSelectorContainer.propTypes = {
  drawerToggle: PropTypes.func.isRequired,
};

export default AddressSelectorContainer;
